import {environment} from "@env/environment";

const languages = [
    {label: 'English', value: 'eng'},
    {label: 'Ukrainian', value: 'ukr'},
];

const groupsMenu = ['edit', 'delete'];

const itemsPerPage = [5, 10, 20, 30, 40, 50, 100];

const maxPlaylistDurationValues = [5, 10, 15];

const maxAdvertisingLength = [5, 10, 15, 30];

const userPageTabs = [
    {key: 'app.myAccount.myProfile', path: '/', featureEnabled: true},
    {key: 'app.myAccount.security', path: 'security', featureEnabled: environment.featureToggle.security},
    {key: 'app.myAccount.timezone', path: 'timezone', featureEnabled: true},
    {key: 'app.myAccount.fallback', path: 'fallback', featureEnabled: true},
    {key: 'app.myAccount.subscribe', path: 'subscribe', featureEnabled: environment.featureToggle.subscription},
    {key: 'app.myAccount.advancedMedia', path: 'device-management', featureEnabled: true},
    {key: 'app.common.adminSettings', path: 'settings', featureEnabled: environment.featureToggle.userManagement},
    {key: 'DWall Market', path: 'marketplace-settings', featureEnabled: environment.featureToggle.marketplace},
    {key: 'Audit', path: 'audit', featureEnabled: true}
];

const advertiserPageTabs = [
    {key: 'app.myAccount.myProfile', path: '/'}
];

const mediaTypes = {
    video: 'video',
    audio: 'audio',
    image: 'image',
    youTube: 'youTube',
    stripe: 'text',
    playlist: 'playlist',
    rss: 'rss',
    webPage: 'webPage',
    file: 'file',
    html: 'html',
    stream: 'stream',
    application: 'application'
};

const tabsList = [
    'video',
    'image',
    'audio',
    'webPage',
    'text',
    'rss',
    'html',
    'stream',
    'application',
    'all',
];

const industriesMarketplaceKeys = [
    'beautySalonBarbershop',
    'bookStore',
    'caffe',
    'carDealership',
    'carServiceStation',
    'carWash',
    'cinema',
    'clinic',
    'clothesAndShoeStore',
    'cosmeticsStore',
    'сonsumerGoodsStore',
    'electronicStore',
    'entertainment',
    'financialServіces',
    'furnitureStore',
    'gasStation',
    'giftsAndAccessoriesStore',
    'groceryStore',
    'hobbiesAndMusic',
    'householdAndDIYStore',
    'jewelryStore',
    'laundryDryCleaning',
    'officeSupplies',
    'petGoods',
    'pharmacy',
    'restaurant',
    'serviceCenter',
    'shoppingMall',
    'sportsGoods',
    'stationeryStore',
    'supermarket',
    'telcoStore',
    'tireService',
    'travelAgency'
];

type ServiceButtonNames = 'cancel' | 'save' | 'ok' | 'delete';

const osNotSupportedRemoteUpdate = ['tizen', 'webos'];

interface IServiceButtonProps {
    cancel?: boolean;
    cancelTitle?: ServiceButtonNames;
    submitTitle?: ServiceButtonNames;
    closePreviousModal?: boolean;
}



export {
    languages,
    userPageTabs,
    advertiserPageTabs,
    maxPlaylistDurationValues,
    maxAdvertisingLength,
    itemsPerPage,
    mediaTypes,
    tabsList,
    groupsMenu,
    ServiceButtonNames,
    IServiceButtonProps,
    industriesMarketplaceKeys,
    osNotSupportedRemoteUpdate
};
